module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gc_layer_off-b6d60a41625c949c74668e0fa62edb0e.jpg";